module.exports = __webpack_public_path__ + "img/close-list.cce9cdea.svg";